import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { FreyaHelperService } from 'src/app/services/freya-helper.service';

import { RulesComponent } from '../rules/rules.component';

@Component({
  selector: 'app-settings-rules',
  templateUrl: './rules-settings.component.html',
  styleUrls: ['./rules-settings.component.scss']
})
export class RulesSettingsComponent implements AfterViewInit {

  @ViewChild('appRules') appRules: RulesComponent;

  constructor(
    public freyaHelper: FreyaHelperService
  ) { }

  ngAfterViewInit(): void {
    // this.appRules.openCreate();

  }

}
